const authState = {
	boletoPermission: false,
	authenticated: false,
	isAdmin: false,
	id: null
};

module.exports = function authReducer(state = authState, {payload, type}) {
	switch (type) {
		case "INIT_AUTH":
			return {
				boletoPermission: payload.boletoPermission,
				authenticated: !!payload,
				id: payload.uid,
				isAdmin: payload.isAdmin
			};

		case "SIGNIN_ADMIN_SUCCESS":
			return {
				boletoPermission: payload.status === 1 && payload.userType === 1,
				authenticated: payload.auth,
				isAdmin: payload.isAdmin,
				id: payload.key
			};

		case "SIGNUP_SUCCESS":
		case "SIGNIN_SUCCESS":
			return {
				boletoPermission: payload.status === 1 && payload.userType === 1,
				authenticated: !!payload,
				isAdmin: payload.isAdmin,
				id: payload.uid
			};

		case "SIGNOUT_SUCCESS":
			return authState;

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/auth.js